export default __webpack_public_path__ + "static/media/psg-prize.3648be19.png";